import axios from 'axios'
import { getItem, clear } from "@utils/localStorage"

export const apiUrl = process.env.REACT_APP_API_URL;

const defaultErrorMessage = 'Đã có lỗi xảy ra';

const getApiFieldErrors = (error) => {
    const rawErrors = error?.response?.data?.errors ?? error?.response?.data?.data;

    if (!rawErrors || Array.isArray(rawErrors) || typeof rawErrors !== 'object') {
        return {};
    }

    return Object.entries(rawErrors).reduce((acc, [field, value]) => {
        if (Array.isArray(value)) {
            acc[field] = value[0];
        } else if (typeof value === 'string') {
            acc[field] = value;
        }

        return acc;
    }, {});
};

const getApiErrorMessage = (error) => {
    const fieldErrors = getApiFieldErrors(error);
    const firstFieldError = Object.values(fieldErrors).find(Boolean);

    if (firstFieldError) {
        return firstFieldError;
    }

    const message = error?.response?.data?.message;

    if (typeof message === 'string' && message.trim()) {
        return message;
    }

    if (message && typeof message === 'object') {
        const nestedFirstError = Object.values(message)
            .flatMap((value) => (Array.isArray(value) ? value : [value]))
            .find(Boolean);

        if (nestedFirstError) {
            return nestedFirstError;
        }
    }

    if (typeof error?.message === 'string' && error.message.trim() && !/^Request failed with status code/.test(error.message)) {
        return error.message;
    }

    return defaultErrorMessage;
};

const isProfileRequest = (config) => {
    const method = (config?.method || 'get').toLowerCase();
    const url = (config?.url || '').replace(/^\/+/, '').split('?')[0];

    return method === 'get' && url === 'profile';
};

const redirectToLogin = () => {
    clear();

    if (window.location.pathname !== '/login') {
        window.location.href = '/login';
    }
};

const normalizeApiError = (error) => {
    error.message = getApiErrorMessage(error);

    return error;
};

const normalizePaginatedResponse = (response) => {
    const payload = response?.data?.data;

    if (payload && Array.isArray(payload.data)) {
        response.data.data = payload.data;
        response.data.meta = payload.meta || null;
        response.data.links = payload.links || null;
    }

    return response;
};

export const authInstance = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const instance = axios.create({
    baseURL: apiUrl,
    headers: { 'Content-Type': 'application/json' }
})

authInstance.interceptors.request.use(
    (config) => {
        const accessTokenString = getItem('access_token');
        if (accessTokenString) {
            try {
                const access_token = JSON.parse(accessTokenString);
                if (access_token) {
                    config.headers.Authorization = `Bearer ${access_token}`;
                }
            } catch (error) {
                console.error('Lỗi khi parse access_token từ localStorage:', error);
            }
        } else {
            console.error('Không tìm thấy access_token trong localStorage');
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

authInstance.interceptors.response.use(
    (response) => {
        return normalizePaginatedResponse(response);
    },
    (error) => {
        const normalizedError = normalizeApiError(error);

        // Nếu bị 401 thì logout và redirect về login
        if (error?.response?.status === 401) {
            redirectToLogin();
        }

        return Promise.reject(normalizedError);
    }
);

instance.interceptors.response.use(
    (response) => normalizePaginatedResponse(response),
    (error) => Promise.reject(normalizeApiError(error))
);
